export default "__VITE_ASSET__tCfHfczl__"